<template>
  <div class="moneyDetail">
    <van-nav-bar
      :title="$t('m.cw_span1')"
      @click-left="onClickLeft"
      left-arrow
    ></van-nav-bar>
    <div class="content">
      <div class="interest_card">
        <div class="interest_item">
          <div class="interest_num">{{ yishou }}</div>
          <div class="interest_label">{{ $t("m.cw_made") }}</div>
        </div>
        <div class="interest_item">
          <div class="interest_num">{{ daishou }}</div>
          <div class="interest_label">{{ $t("m.cw_yunbo") }}</div>
        </div>
      </div>
      <div class="detail_wrap">
        <div class="list_title">
          <img class="list_title__icon" src="../../assets/images/new/mingxi.png" alt="" />
          <span>{{ $t("m.cw_span4") }}</span>
        </div>
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('m.gengduo')"
          @load="onLoad"
        >
          <div class="card_item" v-for="(item, index) in list" :key="index">
            <img class="card_icon" :src="imgs1[index % 6]" alt="" />
            <div class="c2">
              <span class="detail_text">{{ item.desc }}</span>
              <span class="c_time">{{ item.create_time }}</span>
            </div>
            <div class="c3">
              <span class="c_money" :class="item.type == 2 ? 'c_money--out' : ''">{{ item.type == 2 ? '-' : '+' }}{{ formatNum(item) }}</span>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@utils/request";
// import { UserMoney } from "@/components/model";
export default {
  name: "",
  data() {
    return {
      imgs1: [
        require("../../assets/images/new/bb1.png"),
        require("../../assets/images/new/bb2.png"),
        require("../../assets/images/new/bb3.png"),
        require("../../assets/images/new/bb4.png"),
        require("../../assets/images/new/bb5.png"),
        require("../../assets/images/new/xiaoli.png")
      ],
      list: [],
      page: 0,
      loading: false,
      finished: false,
      refreshing: false,
      yishou: 0,
      daishou: 0,
      numBbj: {
        one: 0,
        two: 0
      }
    };
  },
  mounted() {
    this.$toast.loading({
      message: "数据加载中...",
      forbidClick: true,
      duration: 1500
    });
  },
  computed: {
    createDate: function() {
      return function(val) {
        let date = new Date(val * 1000);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        return y + "-" + MM + "-" + d + " " + h + ":" + m;
      };
    }
  },
  methods: {
  formatNum(item) {
  return Number(item.num || 0).toFixed(item.desc && item.desc.indexOf("黄金碎片") !== -1 ? 0 : 2);
},
    async onLoad() {
      this.page = this.page + 1;
      let _this = this;

      request
        .post("/user/log/log", { page: _this.page }, { login: true })
        .then(res => {
          console.log("日利宝列表数据");
          console.log(res);
          this.yishou = Number((res.data.data.tongji && (res.data.data.tongji.made_asset != null ? res.data.data.tongji.made_asset : res.data.data.tongji.yishou)) || 0).toFixed(2);
          this.daishou = Number((res.data.data.tongji && (res.data.data.tongji.yunbo_asset != null ? res.data.data.tongji.yunbo_asset : res.data.data.tongji.daishou)) || 0).toFixed(2);
          if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
          }
          for (var i = 0; i < res.data.data.list.length; i++) {
            this.list.push({
              desc: res.data.data.list[i]["desc"],
              create_time: res.data.data.list[i]["created_at"],
              num: res.data.data.list[i]["num"],
              type: res.data.data.list[i]["type"]
            });
          }
          this.loading = false;

          if (res.data.data.list.length < 10) {
            this.finished = true;
          }
        })
        .catch(err => {
          this.$dialog.fromError(err, "加载失败");
          this.finished = true;
          this.loading = false;
        });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    getLocalTime(nS) {
      return new Date(parseInt(nS) * 1000)
        .toLocaleString()
        .replace(/:\d{1,2}$/, " ");
    }
  },

  filters: {
    formatDate: function(value) {
      let date = new Date(value * 1000);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    }
  },
  components: {}
};
</script>

<style scoped lang="less">
/deep/ .van-hairline--bottom::after {
  border-bottom-width: 0;
}
.moneyDetail /deep/ .van-nav-bar {
  box-shadow: none;
  background-color: transparent;
}
.moneyDetail /deep/ .van-nav-bar__title,
.moneyDetail /deep/ .van-icon {
  color: #fff;
}

.moneyDetail {
  min-height: 100vh;
  background: #f5f5f8;
  padding-bottom: 80px;
  box-sizing: border-box;

  .content {
    margin-top: -46px;
    padding: 58px 15px 10px;
    background-image: url("~@/assets/images/new/gradient-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 175px;
  }

  .interest_card {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 18px 10px;
    border-radius: 10px;
    background: #fff;
  }

  .interest_item {
    flex: 1;
    text-align: center;
  }

  .interest_num {
    font-size: 21px;
    font-weight: 700;
    line-height: 1.2;
    color: var(--bg-color);
  }

  .interest_label {
    margin-top: 6px;
    font-size: 13px;
    color: #666;
  }

  .list_title {
    display: flex;
    align-items: center;
    padding: 12px 12px 8px;
    font-size: 15px;
    font-weight: 700;
    line-height: 20px;
    color: #333;
  }

  .list_title__icon {
    display: block;
    width: 18px;
    height: 18px;
    margin-right: 6px;
    object-fit: contain;
    flex-shrink: 0;
  }

  .detail_wrap {
    margin-top: 12px;
    border-radius: 10px;
    overflow: hidden;
    background: #fff;
  }

  .card_item {
    display: flex;
    align-items: center;
    padding: 14px 12px;
    background: #fff;
    border-bottom: 1px solid #eee;
  }

  .card_item:last-child {
    border-bottom: 0;
  }

  .card_icon {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    margin-right: 10px;
    object-fit: contain;
  }

  .c2 {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  .detail_text {
    font-size: 13px;
    font-weight: 700;
    line-height: 20px;
    color: #333;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
  }

  .c_time {
    margin-top: 4px;
    font-size: 12px;
    line-height: 18px;
    color: #999;
  }

  .c3 {
    flex-shrink: 0;
    margin-left: 10px;
    font-size: 16px;
    font-weight: 700;
  }

  .c_money {
    display: block;
    color: var(--bg-color);
    white-space: nowrap;
    text-align: right;
  }
  .c_money--out {
    color: #333;
  }
}
</style>
